// import TabletsAddressSearch from '../components/shared/TabletsAddressSearch';
import Update from 'immutability-helper';
import { unmountComponentAtNode } from 'react-dom';

import { dispatchAddressChangedEvent } from '../../../../Shared/React/js/components/addressSearch/AddressSearch';
import ResultsAdaptor from '../adaptors/TabletsResultsAdaptor';
import { generateQueryString } from '../utils/TabletsQueryString';

export default class TabletsActions {
    constructor(component) {
        this.component = component;
        this.defaultCriteria = JSON.parse(JSON.stringify(component.state.criteria));
        this.resultsAdaptor = new ResultsAdaptor();

        if (typeof window !== 'undefined') {
            this.initHistoryTracker();

            WhistleOut.setCoverageCookie(this.component.state.coverage);
        }

        this.bindTabletCarousel = this.bindTabletCarousel.bind(this);
    }

    showModal(tabName) {
        if (!tabName) {
            tabName = 'tablet';
        }

        const state = Update(this.component.state, {
            modal: {
                activeTab: { $set: tabName },
                isOpen: { $set: true }
            }
        });
        this.component.setState(state);
    }

    modalHidden() {
        const state = Update(this.component.state, {
            modal: {
                isOpen: { $set: false }
            }
        });
        this.component.setState(state);
    }

    selectTab(tabName) {
        const state = Update(this.component.state, {
            modal: {
                activeTab: { $set: tabName }
            }
        });
        this.component.setState(state);
    }

    changeAddress(value) {
        const newState = {
            criteria: {
                common: {
                    address: { $set: value },
                    suppliers: {
                        values: { $set: [] }
                    },
                    tab: { $set: 'fixed' }
                },
                bundles: { $set: {} }
            }
        };
        const state = Update(this.component.state, newState);
        WhistleOut.setCoverageCookie(null);
        this.search(state);
    }

    hideFeaturedResults() {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    includeFeaturedResults: { $set: false }
                }
            }
        });

        this.search(state, true);
    }

    disableMaximumResultLimits() {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    enforceMaximumResultLimits: { $set: false }
                }
            }
        });

        this.search(state, true);
    }

    changeSuppliers(selectedItems) {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    suppliers: {
                        values: { $set: selectedItems }
                    }
                }
            }
        });

        this.search(state);
    }

    changeNetworks(networks, isLandingPageFilter) {
        var newCriteria = {
            common: {
                suppliers: {
                    values: { $set: [] }
                }
            },
            networkIds: { $set: networks }
        };
        if (isLandingPageFilter) {
            newCriteria.common = {
                results: {
                    productLabel: { $set: null }
                }
            };
        }
        const state = Update(this.component.state, {
            criteria: newCriteria
        });

        this.search(state, isLandingPageFilter);
    }

    changeResultsPerSupplier(singleResult) {
        const numberOfresults = singleResult ? 1 : null;
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    maxResultsPerSupplier: { $set: numberOfresults }
                }
            }
        });

        this.search(state);
    }

    planSummarySupplierChanged(supplier, maxResults) {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    suppliers: {
                        values: { $set: supplier ? [supplier] : [] }
                    },
                    enforceMaximumResultLimits: { $set: supplier ? false : true },
                    tab: { $set: '' },
                    results: {
                        maximumNumberOfResults: { $set: maxResults }
                    }
                }
            }
        });

        this.search(state, true);
    }

    changeSpend(minValue, maxValue) {
        if (
            (minValue === this.component.state.criteria.common.minimumSpend ||
                (minValue === -1 && !this.component.state.criteria.common.minimumSpend)) &&
            (maxValue === this.component.state.criteria.common.maximumSpend ||
                (maxValue === -1 && !this.component.state.criteria.common.maximumSpend))
        ) {
            return;
        }

        const state = Update(this.component.state, {
            criteria: {
                common: {
                    maximumSpend: { $set: maxValue },
                    minimumSpend: { $set: minValue }
                }
            }
        });

        this.search(state, this.component.embeddedMode === 'PartlyEmbedded'); // Ajax when partly embedded
    }

    changeData(value, isLandingPageFilter) {
        if (value === this.component.state.criteria.minimumData) {
            return;
        }
        var newCriteria = {
            minimumData: { $set: value }
        };
        if (isLandingPageFilter) {
            newCriteria.common = {
                results: {
                    productLabel: { $set: null }
                }
            };
        }
        const state = Update(this.component.state, {
            criteria: newCriteria
        });

        this.search(state, this.component.embeddedMode === 'PartlyEmbedded' || isLandingPageFilter); // Ajax when partly embedded
    }

    changeSupplier(value) {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    suppliers: {
                        values: { $set: [value] }
                    }
                }
            }
        });

        this.search(state, true);
    }

    changeTablet(tabletShortUrl, includeSimOnly, simType, isAjax) {
        if (
            tabletShortUrl === this.component.state.criteria.tabletShortUrl &&
            includeSimOnly === this.component.state.criteria.includeSimOnly &&
            simType === this.component.state.criteria.simType
        ) {
            return;
        }

        const state = Update(this.component.state, {
            criteria: {
                tabletShortUrl: { $set: tabletShortUrl },
                includeSimOnly: { $set: includeSimOnly },
                simType: { $set: simType }
            }
        });

        this.search(state, isAjax);
    }

    changeUpfrontCost(value) {
        const state = Update(this.component.state, {
            criteria: {
                maximumTabletUpfrontCost: { $set: value }
            }
        });

        this.search(state, true);
    }

    changeSort(expression, isAscending) {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    resultsSortExpression: { $set: expression },
                    resultsSortAscending: { $set: isAscending }
                }
            }
        });

        this.search(state, true);
    }

    retrySearch() {
        const state = Update(this.component.state, {
            criteria: {
                connectionTypes: {
                    values: {
                        $set: []
                    }
                }
            }
        });
        this.search(state, null, true);
    }

    changeTab(value) {
        const state = Update(this.component.state, {
            criteria: {
                common: {
                    tab: { $set: value }
                }
            }
        });
        this.component.setState(state);
        const queryString = generateQueryString(state.criteria, state.allConnectionsSelected);
        if (this.component.embeddedMode !== 'FullyEmbedded' && this.component.embeddedMode !== 'PartlyEmbedded') {
            this.HistoryWrapper.pushQuery(queryString);
        }
    }

    widenResults(options) {
        const criteria = {};
        criteria.common = {};
        if (options.reduceData) {
            criteria.minimumData = { $set: 0 };
        }
        if (options.increasePriceRange) {
            criteria.common.maximumSpend = { $set: -1 };
            criteria.common.minimumSpend = { $set: 0 };
        }
        if (options.includeAllContractLengths) {
            criteria.common.contractTerms = { $set: [] };
        }
        if (options.includeAllSuppliers === true) {
            criteria.common.suppliers = { $set: [] };
            criteria.networkIds = { $set: [] };
        }
        if (options.noDealsOnly === true) {
            criteria.common.includeOffersWithCampaignOnly = { $set: false };
        }
        if (options.fullSpeedData === true) {
            criteria.compareUnthrottledData = { $set: false };
        }
        if (options.removeMaxUpfront) {
            criteria.maximumTabletUpfrontCost = { $set: null };
        }
        if (options.includeAllPriceTypes) {
            criteria.tabletPriceTypes = { $set: [] };
        }
        if (options.includeAllPlanTypes) {
            criteria.planTypes = { $set: [] };
        }

        if (options.sortBy === true) {
            criteria.common.resultsSortExpression = { $set: null };
            criteria.common.resultsSortAscending = { $set: true };
        }
        const state = Update(this.component.state, { criteria: criteria });

        this.search(state);
    }

    changeContractType(contractType, hide) {
        const currentComponent = this.component;
        const state = wo$.extend(true, {}, currentComponent.state);

        if (contractType !== 'prepaid') {
            if (hide === true) {
                if (state.criteria.common.contractTerms && state.criteria.common.contractTerms.length > 1) {
                    state.criteria.common.contractTerms = state.criteria.common.contractTerms.filter(function (c) {
                        return c !== parseInt(contractType);
                    });
                } else {
                    state.criteria.common.contractTerms = this.component.filters.allContractTerms.filter(function (c) {
                        return c !== parseInt(contractType);
                    });
                }
            } else {
                state.criteria.common.contractTerms = [];
                state.criteria.common.contractTerms.push(parseInt(contractType));
            }
        }

        this.search(state);
    }

    updateCriteria(criteria) {
        const state = Update(this.component.state, {
            criteria: { $set: criteria }
        });
        this.search(state, true, true);
    }

    bindResults() {
        this.resultsAdaptor.unbindAll();
        this.resultsAdaptor.bindCoverageErrorStrip(() => this.search());
        this.resultsAdaptor.bindSort((expression, isAscending) => this.changeSort(expression, isAscending));
        this.resultsAdaptor.bindTab(tab => this.changeTab(tab));
        this.resultsAdaptor.bindWidenResults(options => this.widenResults(options));
        this.resultsAdaptor.bindLoadMore((tab, current) => this.loadMoreResults(tab, current));
        this.resultsAdaptor.bindHideFeatureResults(() => this.hideFeaturedResults());
        this.resultsAdaptor.bindDisableMaximumResultLimits(() => this.disableMaximumResultLimits());
        this.resultsAdaptor.bindPlanSummary((supplier, maxResults) =>
            this.planSummarySupplierChanged(supplier, maxResults, true)
        );
        this.resultsAdaptor.bindTabletSummary(tabletShortUrl => this.changeTablet(tabletShortUrl, null, null, true));

        this.resultsAdaptor.bindLandingPageCriteria('criteria-data', data => this.changeData(data, true));
        this.resultsAdaptor.bindLandingPageCriteria('criteria-network', network =>
            this.changeNetworks([network], true)
        );
        this.resultsAdaptor.bindLandingPageCriteria('criteria-supplier', supplier => this.changeSupplier(supplier));
        this.resultsAdaptor.bindCriteriaFilters(this.defaultCriteria, criteria => this.updateCriteria(criteria));
        this.resultsAdaptor.bindSaveSearch();

        this.bindTabletCarousel();
        wo$('.responsive').off('init', this.bindTabletCarousel).on('init', this.bindTabletCarousel);
        this.resultsAdaptor.bindCoverageNetworks(networks => {
            this.changeNetworks(networks);
        });
        this.resultsAdaptor.bindSupplierActions(
            (supplierShortUrl, hide, showOneResultPerCarrier) => {
                if (!supplierShortUrl) {
                    if (showOneResultPerCarrier === true) {
                        this.changeResultsPerSupplier(true);
                    } else if (showOneResultPerCarrier === false) {
                        this.changeResultsPerSupplier(false);
                    } else {
                        this.changeSuppliers([]);
                    }
                } else if (hide) {
                    let allSuppliers = this.component.state.criteria.common.suppliers.values;
                    if (!allSuppliers || allSuppliers.length <= 0) {
                        allSuppliers = this.component.props.filters.allSuppliersShortUrls;
                    }
                    const selectedSuppliers = allSuppliers.filter(s => s !== supplierShortUrl);
                    this.changeSuppliers(selectedSuppliers);
                } else {
                    this.changeSuppliers([supplierShortUrl]);
                }
            },
            tab => {
                this.showModal(tab);
            }
        );
        this.resultsAdaptor.bindCta();

        this.resultsAdaptor.bindCoverageMap();

        this.resultsAdaptor.bindSpecsGallery();
    }

    bindTabletCarousel() {
        this.resultsAdaptor.bindTabletCarousel(
            this.component.state.criteria.tabletShortUrl,
            (tabletShortUrl, includeSimOnly, simType) =>
                this.changeTablet(tabletShortUrl, includeSimOnly, simType, true)
        );
    }

    loadMoreResults(tab, current) {
        const state = this.component.state;
        if (tab !== 'all' && state.criteria.common.tab !== tab) {
            return;
        }

        const url = this.component.props.pagedResultsUrl;
        let queryString = generateQueryString(state.criteria);
        if (queryString.length > 0) {
            queryString = `${queryString}&current=${current}`;
        } else {
            queryString = `current=${current}`;
        }
        const fullUrl = `${url}?${queryString}`;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        wo$.ajax({
            type: 'GET',
            url: fullUrl,
            success: function (results) {
                that.resultsAdaptor.appendLoadMoreResults(tab, results);
            }
        });
    }

    search(state, isAjax, force) {
        const currentComponent = this.component;
        if (!force && state && JSON.stringify(currentComponent.state.criteria) === JSON.stringify(state.criteria)) {
            return;
        }
        const componentState = state || currentComponent.state;
        this.doSearch(componentState, isAjax);
    }

    doSearch(state, isAjax) {
        const currentComponent = this.component;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;

        WhistleOut.startProgress('#search-results-partial', 0.1, 50);

        if (isAjax || currentComponent.embeddedMode === 'None') {
            const componentState = state || currentComponent.state;
            const resultsUrl = currentComponent.resultsUrl;
            const queryString = generateQueryString(componentState.criteria);
            const fullUrl = queryString.length ? `${resultsUrl}?${queryString}` : resultsUrl;
            wo$.ajax({
                url: fullUrl,
                type: 'GET',
                success: function (result) {
                    const $results = wo$('#results-container');
                    const $addressBar = wo$('[data-search-address] > div');
                    if ($addressBar.length > 0) {
                        unmountComponentAtNode($addressBar[0]);
                    }

                    $results.html(result.html);

                    that.component.setState(
                        Update(state, {
                            loading: { $set: true },
                            suppliers: { $set: result.suppliers },
                            criteria: { $set: result.criteria },
                            coverage: { $set: result.coverage },
                            unavailableConnectionTypes: { $set: result.unavailableConnectionTypes },
                            allConnectionsSelected: { $set: result.allAvailableConnectionsSelected }
                        })
                    );

                    WhistleOut.setCoverageCookie(result.coverage);
                    WhistleOut.applyPopover($results);
                    that.bindResults();
                    WhistleOut.getAds('Tablets');

                    wo$(window).resize();
                    WhistleOut.endProgress();

                    if (currentComponent.embeddedMode === 'None') {
                        const resultQueryString = generateQueryString(
                            result.criteria,
                            result.allAvailableConnectionsSelected
                        );

                        dispatchAddressChangedEvent({
                            sender: this,
                            address: result.criteria.common.address
                        });

                        if (
                            that.component.embeddedMode !== 'FullyEmbedded' &&
                            that.component.embeddedMode !== 'PartlyEmbedded'
                        ) {
                            that.HistoryWrapper.pushQuery(resultQueryString);
                        }
                        that.trackPage(true);
                    }
                },
                error: function () {
                    that.component.setState(state, () => {
                        WhistleOut.endProgress();
                        const modal = wo$('#modal-error');
                        modal.modal('show');
                    });
                }
            });
        } else {
            const searchUrl = currentComponent.searchUrl;
            //TODO: Set other criteria that should be reset when navigating to full results from embedded mode
            let newState = {
                criteria: {
                    common: {
                        results: {
                            hideEmptyTabs: { $set: false },
                            showAll: { $set: false },
                            hideSort: { $set: false },
                            hideShare: { $set: false },
                            hideWidenResults: { $set: false },
                            showRowSorts: { $set: true },
                            showRowFilters: { $set: true },
                            maximumNumberOfResults: { $set: null },
                            hideCoverage: { $set: false },
                            productLabel: { $set: null }
                        }
                    }
                }
            };
            let resultState = Update(state || currentComponent.state, newState);
            if (resultState.criteria.common.address && currentComponent.suppressCoverageCheck === false) {
                const coveragePromise = this.resultsAdaptor.getCoveragePromise(
                    resultState.criteria,
                    currentComponent.coverageUrl
                );
                coveragePromise.then(connectionTypes => {
                    if (connectionTypes) {
                        resultState = Update(resultState, {
                            criteria: { connectionTypes: { values: { $set: connectionTypes.map(t => t.shortUrl) } } }
                        });
                    }
                    const queryString = generateQueryString(resultState.criteria);
                    const fullUrl = queryString.length ? `${searchUrl}?${queryString}` : searchUrl;
                    location.href = fullUrl;
                });
            } else {
                const queryString = generateQueryString(resultState.criteria);
                const fullUrl = queryString.length ? `${searchUrl}?${queryString}` : searchUrl;

                if (!resultState.criteria.common.address || !resultState.criteria.common.address.state) {
                    WhistleOut.getCurrentLocation(
                        function (e) {
                            const address = e.label;
                            if (address.length > 1) {
                                const updatedQueryString = WhistleOut.appendQueryParam(
                                    queryString,
                                    'address=' + address
                                );
                                const updatedFullUrl = updatedQueryString.length
                                    ? `${searchUrl}?${updatedQueryString}`
                                    : searchUrl;
                                location.href = updatedFullUrl;
                            } else {
                                location.href = fullUrl;
                            }
                        },
                        function () {
                            location.href = fullUrl;
                        }
                    );
                } else {
                    location.href = fullUrl;
                }
            }
        }
    }

    initHistoryTracker() {
        WhistleOut.initHistoryTracker(this);
    }

    trackPage(isAjax, doNotRetry) {
        if (WhistleOut.getAnalyticsClientSideData() == null) {
            if (doNotRetry === true) {
                return;
            }
            setTimeout(() => this.trackPage(isAjax, true), 500);
        } else {
            const resultCount = wo$('#search-results-partial').data('result-count');
            const values = [];
            const criteria = this.component.state.criteria;
            let currentSupplierId = null;
            if (criteria.common.currentSupplierShortUrl && criteria.common.currentSupplierShortUrl.length) {
                currentSupplierId = this.component.state.suppliers.items.filter(
                    i => i.shortUrl === criteria.common.currentSupplierShortUrl
                )[0].id;
            }
            values.push(currentSupplierId);
            values.push(criteria.common.minimumSpend);
            values.push(criteria.common.maximumSpend);
            values.push(criteria.minimumData);
            values.push(criteria.common.includeOffersWithCampaignOnly);
            values.push(criteria.common.resultsSortExpression);
            values.push(criteria.common.resultsSortAscending);
            values.push(resultCount);
            if (criteria.common.address) {
                values.push(criteria.common.address.placeId);
                values.push(criteria.common.address.label);
                values.push(criteria.common.address.state ? criteria.common.address.state.shortName : null);
                values.push(criteria.common.address.state ? criteria.common.address.state.longName : null);
                values.push(criteria.common.address.city ? criteria.common.address.city.longName : null);
                values.push(criteria.common.address.postcode ? criteria.common.address.postcode.longName : null);
            } else {
                values.push(null);
                values.push(null);
                values.push(null);
                values.push(null);
                values.push(null);
                values.push(null);
            }
            values.push(criteria.tabletShortUrl);
            var valuesString = values.join('|');
            WhistleOut.trackPageView(null, valuesString, isAjax);

            if (isAjax) {
                var value = WhistleOut.getRemarketingData();
                if (value) {
                    value.data.postcode =
                        criteria.common.address && criteria.common.address.postcode
                            ? criteria.common.address.postcode.longName
                            : null;
                    value.data.data = criteria.data;
                    value.data.supplier = criteria.common.suppliers.values.join();
                    value.data.connectionType = criteria.connectionTypes.values.join();
                    value.data.bundles = criteria.bundles.selectedTypes.join();
                    WhistleOut.remarketing(value);
                }
            }
        }
    }
}
